import { gsap, Quint } from "gsap";

window.mobileNav = function() {
  return {
    show: false,
    toggle() {
      if (this.show) {
        this.close();
      } else {
        this.open();
      }
    },
    open() {
      this.show = true;
      console.log(this.$refs.coool);
      lockWindow();
    },
    close() {
      this.show = false;
      releaseWindow();
    },
  };
};

window.mobileSubNav = function() {
  return {};
};

function lockWindow() {
  document.body.style.top = `-${window.scrollY}px`;
  document.body.style.position = "fixed";
}
function releaseWindow() {
  document.body.style.position = "";
  window.scrollTo(0, -parseInt(document.body.style.top, 10));
}
